import { EMPTY_FIELD } from 'support/helpers/const/const';
import { CollapsibleSummaryRow } from 'components/WebEDI/DocumentSummary/components/CollapsibleSummaryRow/CollapsibleSummaryRow';

import { SummaryAccordionItem } from '../types';

type SummaryAccordionBodyProps = {
  items: Array<SummaryAccordionItem>;
};
export const SummaryAccordionBody = ({ items }: SummaryAccordionBodyProps) => {
  return (
    <div className="flex w-full flex-col px-8">
      {items.map((item) =>
        item.subItems?.length ? (
          <div key={item.label} className="border-b border-gray-200 py-4">
            <CollapsibleSummaryRow
              label={item.label}
              value={item.value || EMPTY_FIELD}
              subItems={item.subItems}
              className="flex items-center justify-between"
              labelClassName="text-sm text-gray-700"
              valueClassName="text-sm font-semibold text-gray-700"
              subItemsClassName="text-sm text-gray-700"
            />
          </div>
        ) : (
          <div key={item.label} className="flex items-center justify-between border-b border-gray-200 py-4">
            <span className="text-sm text-gray-700">{item.label}</span>
            <span className="text-sm font-semibold text-gray-700">{item.value || EMPTY_FIELD}</span>
          </div>
        ),
      )}
    </div>
  );
};
